/* BADINKA Clearance PDP: translated remaining stock for the selected option(s). */
(function () {
  'use strict';

  if (window.bdkClearanceStockInitialized) return;
  window.bdkClearanceStockInitialized = true;

  var noticeSelector = '[data-bdk-clearance-low-stock]';
  var mapCache = new WeakMap();

  function stockVariants(notice) {
    if (mapCache.has(notice)) return mapCache.get(notice);
    var variants = [];
    var script = notice.nextElementSibling;
    if (script && script.matches('[data-bdk-clearance-stock-map]')) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (Array.isArray(parsed)) variants = parsed;
      } catch (error) {
        console.warn('[BADINKA] Could not read Clearance stock data.', error);
      }
    }
    mapCache.set(notice, variants);
    return variants;
  }

  // Read the visible option controls, not a potentially pre-filled fallback
  // variant ID: BADINKA intentionally starts with no selected size.
  function selectedOptions(section) {
    var choices = [];
    section.querySelectorAll('[data-product-variants] .selector-wrapper[data-option-position]').forEach(function (wrapper) {
      var position = Number(wrapper.getAttribute('data-option-position')) - 1;
      if (!Number.isInteger(position) || position < 0) return;

      var radio = wrapper.querySelector('input[data-single-option-selector][type="radio"]:checked');
      var dropdown = wrapper.querySelector('input[data-single-option-selector][data-popout-input]');
      var select = wrapper.querySelector('select[data-single-option-selector]');
      choices[position] = (radio && radio.value) || (dropdown && dropdown.value) || (select && select.value) || '';
    });
    return choices;
  }

  function update(notice) {
    var section = notice.closest('[data-section-type="product"]');
    if (!section) return;

    var options = selectedOptions(section);
    var variants = stockVariants(notice).filter(function (variant) {
      return variant.available && Array.isArray(variant.options) && options.every(function (selected, index) {
        return !selected || variant.options[index] === selected;
      });
    });

    // If any matching sellable variant has no reliable stock count, hide the
    // notice rather than wrongly claiming that only a few units are left.
    var known = variants.length > 0 && variants.every(function (variant) {
      return Number.isInteger(variant.quantity) && variant.quantity > 0;
    });
    var total = known ? variants.reduce(function (sum, variant) {
      return sum + variant.quantity;
    }, 0) : 0;
    var show = known && total >= 1 && total <= 9;

    if (show) {
      var template = notice.getAttribute('data-bdk-stock-template') || '';
      notice.textContent = template.replace('__BDK_STOCK__', String(total));
    }
    notice.hidden = !show;
  }

  function updateSection(section) {
    if (!section) return;
    section.querySelectorAll(noticeSelector).forEach(update);
  }

  function initialize(root) {
    if (!root) return;
    if (root.matches && root.matches(noticeSelector)) update(root);
    if (root.querySelectorAll) root.querySelectorAll(noticeSelector).forEach(update);
  }

  document.addEventListener('theme:variant:change', function (event) {
    var section = event.target && event.target.closest && event.target.closest('[data-section-type="product"]');
    updateSection(section);
  });

  // Read the completed state after radio changes / custom popout selectors.
  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.matches || !event.target.matches('[data-single-option-selector]')) return;
    var section = event.target.closest('[data-section-type="product"]');
    if (section) requestAnimationFrame(function () { updateSection(section); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
